/* unplugin-vue-components disabled */import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-55b47d2e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex"
};
const _hoisted_2 = {
  key: 0,
  class: "menus"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "main-container flex-1"
};
import { usePermissionStore } from '@/store/modules/permission';
import { storeToRefs } from 'pinia';
import { compare } from '@ultra/share/utils/index';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const GSManage = defineAsyncComponent(() => import('./GSManage/index.vue'));
    const BindManage = defineAsyncComponent(() => import('./bindManage/index.vue'));
    const PromotionData = defineAsyncComponent(() => import('./promotion/index.vue'));
    const Income = defineAsyncComponent(() => import('./income/index.vue'));
    const objMenu = {
      GSManage: {
        title: 'GS管理',
        key: 'channelManage',
        component: shallowRef(GSManage),
        role: 'GSManage',
        sort: 1
      },
      bindManage: {
        title: '绑定管理',
        key: 'bindManage',
        component: shallowRef(BindManage),
        role: 'bindManage',
        sort: 2
      },
      promotionManage: {
        title: '推广数据',
        key: 'promotionData',
        component: shallowRef(PromotionData),
        role: 'promotionManage',
        sort: 3
      },
      myIncome: {
        title: '我的收益',
        key: 'income',
        component: shallowRef(Income),
        role: 'myIncome',
        sort: 4
      }
    };
    const menus = ref([]);
    const {
      btnPermissions
    } = storeToRefs(usePermissionStore());
    const active = ref();
    const handleChange = item => {
      active.value = item;
    };
    const gsId = ref();
    const handleToBind = id => {
      gsId.value = id;
      active.value = {
        title: '绑定管理',
        key: 'bindManage',
        component: shallowRef(BindManage),
        role: 'myIncome'
      };
    };
    watch(() => btnPermissions.value, val => {
      menus.value = [];
      if (val) {
        let newArr = Array.from(new Set(val));
        newArr.forEach(item => {
          if (objMenu[item]) {
            var _menus$value;
            (_menus$value = menus.value) === null || _menus$value === void 0 ? void 0 : _menus$value.push(objMenu[item]);
          }
        });
        menus.value.sort(compare('sort'));
        active.value = menus.value[0];
        console.log('objMenu', menus.value);
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      var _unref3;
      const _directive_has = _resolveDirective("has");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(menus).length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menus), item => {
        var _unref2;
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: item.key,
          class: _normalizeClass(['menu', ((_unref2 = _unref(active)) === null || _unref2 === void 0 ? void 0 : _unref2.key) === item.key ? 'active' : '']),
          onClick: $event => handleChange(item)
        }, [_createTextVNode(_toDisplayString(item.title), 1)], 10, _hoisted_3)), [[_directive_has, item.role]]);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [(_openBlock(), _createBlock(_resolveDynamicComponent((_unref3 = _unref(active)) === null || _unref3 === void 0 ? void 0 : _unref3.component), {
        gsId: _unref(gsId),
        onToBind: handleToBind
      }, null, 40, ["gsId"]))])]);
    };
  }
});